@if (!isRedirecting) {
<div class="flex-1 bg-base-100 flex flex-col">
  <main class="flex-1">
    <section class="container mx-auto max-w-[1200px] px-5 py-8">
      <h1 class="text-2xl font-semibold text-base-content mb-1">Welcome, {{ userName }}!</h1>
    </section>

    <section class="container mx-auto max-w-[1200px] px-5 pb-8">
      <!-- auto-rows-fr so every row is as tall as the tallest, not just every tile
           within a row. Stretch equalises tiles across a row; it says nothing about
           two rows, so a second row holding one tile came out shorter than the first. -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 auto-rows-fr">

        <!-- Online Colo -->
        <vb-card bgColor="base-200" class="app-tile block min-h-[220px] [&>div]:!p-6 transition-opacity duration-200" [class.opacity-50]="isRolesLoading" [class.cursor-pointer]="isTileClickable('colo')" [class.hover:shadow-md]="isTileClickable('colo')" (click)="onTileClick('colo')">
          <div class="flex flex-col h-full justify-between">
            <div>
              <div class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" [class]="appRoles.colo.hasAccess ? 'h-8 w-8 text-primary' : 'h-8 w-8 text-base-content/40'" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.14 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0" />
            </svg>
          </div>
              <h3 [class]="appRoles.colo.hasAccess ? 'text-primary font-semibold text-lg mb-2' : 'text-base-content/40 font-semibold text-lg mb-2'">Online Colo</h3>
              <p [class]="appRoles.colo.hasAccess ? 'text-base-content/70 text-sm' : 'text-base-content/40 text-sm'">Streamline tenant colocation by managing applications, documents, and site details in one centralized platform.</p>
            </div>
            <div class="pt-4 min-h-10">
              @if (!isRolesLoading) {
              @if (appRoles.colo.hasAccess) {
                <vb-button variant="primary" size="sm" [rounded]="true" [iconOnly]="true" (click)="$event.stopPropagation(); navigateToColo()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </vb-button>
              }
            }
                      </div>
          </div>
        </vb-card>

        <!-- Site Locator -->
        <vb-card bgColor="base-200" class="app-tile block min-h-[220px] [&>div]:!p-6 transition-opacity duration-200" [class.opacity-50]="isRolesLoading || isSiteLocatorStatusLoading" [class.cursor-pointer]="isTileClickable('siteLocator')" [class.hover:shadow-md]="isTileClickable('siteLocator')" (click)="onTileClick('siteLocator')">
          <div class="flex flex-col h-full justify-between">
            <div>
              <div class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" [class]="appRoles.siteLocator.hasAccess ? 'h-8 w-8 text-primary' : 'h-8 w-8 text-base-content/40'" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
              <h3 [class]="appRoles.siteLocator.hasAccess ? 'text-primary font-semibold text-lg mb-2' : 'text-base-content/40 font-semibold text-lg mb-2'">Site Locator</h3>
              <p [class]="appRoles.siteLocator.hasAccess ? 'text-base-content/70 text-sm' : 'text-base-content/40 text-sm'">Quickly search, navigate, and manage site locations to improve network planning, optimization, and expansion.</p>
            </div>
            <div class="pt-4 min-h-10">
              @if (!isRolesLoading && !isSiteLocatorStatusLoading) {
              @if (appRoles.siteLocator.hasAccess) {
                <vb-button variant="primary" size="sm" [rounded]="true" [iconOnly]="true" (click)="$event.stopPropagation(); navigateToSiteLocator()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </vb-button>
              } @else if (siteLocatorRequestStatus.hasRequested && siteLocatorRequestStatus.status !== 'UNLOCKED') {
                <vb-badge [variant]="siteLocatorRequestStatus.status === 'Denied' ? 'error' : 'warning'" size="md">
                  {{ siteLocatorRequestStatus.status === 'Denied' ? 'Denied' : 'Pending' }}
                </vb-badge>
              } @else {
                <vb-button variant="outline" size="sm" (click)="$event.stopPropagation(); openRequestAccessModal('Site Locator', 'siteLocator')">
                  Request Access
                </vb-button>
              }
            }
                      </div>
          </div>
        </vb-card>

        <!-- Vertical Intel (hidden in production) -->
        @if (!isProduction) {
        <vb-card bgColor="base-200" class="app-tile block min-h-[220px] [&>div]:!p-6 transition-opacity duration-200" [class.opacity-50]="isRolesLoading || isViStatusLoading" [class.cursor-pointer]="isTileClickable('verticalIntel')" [class.hover:shadow-md]="isTileClickable('verticalIntel')" (click)="onTileClick('verticalIntel')">
          <div class="flex flex-col h-full justify-between">
            <div>
              <div class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" [class]="appRoles.verticalIntel.hasAccess ? 'h-8 w-8 text-primary' : 'h-8 w-8 text-base-content/40'" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z" />
              <path d="M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z" />
              <path d="M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4" />
              <path d="M17.599 6.5a3 3 0 0 0 .399-1.375" />
              <path d="M6.003 5.125A3 3 0 0 0 6.401 6.5" />
              <path d="M3.477 10.896a4 4 0 0 1 .585-.396" />
              <path d="M19.938 10.5a4 4 0 0 1 .585.396" />
              <path d="M6 18a4 4 0 0 1-1.967-.516" />
              <path d="M19.967 17.484A4 4 0 0 1 18 18" />
            </svg>
          </div>
              <h3 [class]="appRoles.verticalIntel.hasAccess ? 'text-primary font-semibold text-lg mb-2' : 'text-base-content/40 font-semibold text-lg mb-2'">Vertical Intel</h3>
              <p [class]="appRoles.verticalIntel.hasAccess ? 'text-base-content/70 text-sm' : 'text-base-content/40 text-sm'">Search Vertical Bridge's tower portfolio to find colocation candidates - map-based site lookup with specs, imagery, and a wishlist to track the ones you want</p>
            </div>
            <div class="pt-4 min-h-10">
              @if (!isRolesLoading && !isViStatusLoading) {
              @if (appRoles.verticalIntel.hasAccess) {
                <vb-button variant="primary" size="sm" [rounded]="true" [iconOnly]="true" (click)="$event.stopPropagation(); navigateToVerticalIntel()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </vb-button>
              } @else if (appRoles.verticalIntel.status === 'revoked') {
                <div class="flex flex-col gap-1.5 items-start">
                  <vb-badge variant="error" size="md">Access revoked</vb-badge>
                  <p class="text-xs text-base-content/70">Access to Vertical Intel has been revoked. Contact your administrator.</p>
                </div>
              } @else if (viRequestStatus.hasRequested && viRequestStatus.status !== 'Approved') {
                <vb-badge [variant]="viRequestStatus.status === 'Denied' ? 'error' : 'warning'" size="md">
                  {{ viRequestStatus.status === 'Denied' ? 'Denied' : 'Pending' }}
                </vb-badge>
              } @else {
                <vb-button variant="outline" size="sm" (click)="$event.stopPropagation(); openRequestAccessModal('Vertical Intel', 'verticalIntel')">
                  Request Access
                </vb-button>
              }
            }
                      </div>
          </div>
        </vb-card>
        }

        <!-- Partner Portal — wait for the colo-app count to resolve before
             rendering, so colo users never see the tile flash in then out. -->
        @if (isPartnerPortalTileResolved && !isPartnerPortalTileHidden) {
        <vb-card bgColor="base-200" class="app-tile block min-h-[220px] [&>div]:!p-6 transition-opacity duration-200" [class.opacity-50]="isRolesLoading" [class.cursor-pointer]="isTileClickable('partnerPortal')" [class.hover:shadow-md]="isTileClickable('partnerPortal')" (click)="onTileClick('partnerPortal')">
          <div class="flex flex-col h-full justify-between">
            <div>
              <div class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" [class]="appRoles.partnerPortal.hasAccess ? 'h-8 w-8 text-primary' : 'h-8 w-8 text-base-content/40'" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
            </svg>
          </div>
              <h3 [class]="appRoles.partnerPortal.hasAccess ? 'text-primary font-semibold text-lg mb-2' : 'text-base-content/40 font-semibold text-lg mb-2'">Partner Portal</h3>
              <p [class]="appRoles.partnerPortal.hasAccess ? 'text-base-content/70 text-sm' : 'text-base-content/40 text-sm'">Built for real estate partners, access essential site details and generate comprehensive reports to support faster decisions.</p>
            </div>
            <div class="pt-4 min-h-10">
              @if (!isRolesLoading) {
              @if (appRoles.partnerPortal.hasAccess) {
                <vb-button variant="primary" size="sm" [rounded]="true" [iconOnly]="true" (click)="$event.stopPropagation(); navigateToPartnerPortal()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </vb-button>
              } @else if (isPartnerPortalStatusUnknown) {
                <div class="flex flex-col gap-1.5 items-start">
                  <vb-badge variant="warning" size="md">Status unavailable</vb-badge>
                  <p class="text-xs text-base-content/70">We couldn't check your Partner Portal access just now. Refresh to try again.</p>
                </div>
              } @else if (isPartnerPortalPending) {
                <vb-badge variant="warning" size="md">Pending</vb-badge>
              } @else {
                <vb-button variant="outline" size="sm" (click)="$event.stopPropagation(); openRequestAccessModal('Partner Portal', 'partnerPortal')">
                  Request Access
                </vb-button>
              }
            }
                      </div>
          </div>
        </vb-card>
        }

        <!-- Vertical Works — hidden where it has no URL yet (production).
             The only tile that branches by population: internal users get it
             disabled, external users get Request Access. -->
        @if (!isVerticalWorksTileHidden) {
        <vb-card bgColor="base-200" class="app-tile block min-h-[220px] [&>div]:!p-6 transition-opacity duration-200" [class.opacity-50]="isRolesLoading" [class.cursor-pointer]="isTileClickable('verticalWorks')" [class.hover:shadow-md]="isTileClickable('verticalWorks')" (click)="onTileClick('verticalWorks')">
          <div class="flex flex-col h-full justify-between">
            <div>
              <div class="mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" [class]="appRoles.verticalWorks.hasAccess ? 'h-8 w-8 text-primary' : 'h-8 w-8 text-base-content/40'" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M11.42 15.17L17.25 21A2.652 2.652 0 0021 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 11-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 004.486-6.336l-3.276 3.277a3.004 3.004 0 01-2.25-2.25l3.276-3.276a4.5 4.5 0 00-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437L11.42 15.17" />
            </svg>
          </div>
              <h3 [class]="appRoles.verticalWorks.hasAccess ? 'text-primary font-semibold text-lg mb-2' : 'text-base-content/40 font-semibold text-lg mb-2'">Vertical Works</h3>
              <p [class]="appRoles.verticalWorks.hasAccess ? 'text-base-content/70 text-sm' : 'text-base-content/40 text-sm'">Post field work to approved vendors, compare their bids, and track jobs from award through completion.</p>
            </div>
            <div class="pt-4 min-h-10">
              @if (!isRolesLoading) {
              @if (appRoles.verticalWorks.hasAccess) {
                <vb-button variant="primary" size="sm" [rounded]="true" [iconOnly]="true" (click)="$event.stopPropagation(); navigateToVerticalWorks()">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </vb-button>
              } @else if (isVerticalWorksDisabled) {
                <!-- Ordered before the internal branch: a disabled account is
                     the same dead end for either population, and re-requesting
                     would either be rejected or silently re-open it.
                     Badge plus sentence mirrors the Vertical Intel revoked
                     state above: the badge carries the label, the paragraph
                     carries the instruction, because a badge sized to a full
                     sentence stops reading as a status. -->
                <div class="flex flex-col gap-1.5 items-start">
                  <vb-badge variant="error" size="md">Access disabled</vb-badge>
                  <p class="text-xs text-base-content/70">Your Vertical Works access has been disabled. Contact your administrator to have it restored.</p>
                </div>
              } @else if (isVerticalWorksStatusUnknown) {
                <!-- Ordered before the internal branch: "Not provisioned"
                     asserts the roster was consulted, and a check that did not
                     answer established nothing. Also before Request Access,
                     which it withholds: a failed check is not evidence the
                     user lacks an account.
                     warning, not error: the user's access may well be intact
                     and it is the check that failed, so this must not read as
                     a verdict on their account. -->
                <div class="flex flex-col gap-1.5 items-start">
                  <vb-badge variant="warning" size="md">Status unavailable</vb-badge>
                  <p class="text-xs text-base-content/70">We couldn't check your Vertical Works access just now. Refresh to try again.</p>
                </div>
              } @else if (isVerticalWorksInternalUser) {
                <!-- info, not error: nothing has gone wrong and nothing was
                     withdrawn. The internal roster is a configured list, so
                     this is the one outcome of the three that is purely
                     informational. -->
                <div class="flex flex-col gap-1.5 items-start">
                  <vb-badge variant="info" size="md">Not provisioned</vb-badge>
                  <p class="text-xs text-base-content/70">Internal access to Vertical Works is granted by an administrator. Contact your administrator to be added.</p>
                </div>
              } @else {
                <!-- No Pending badge: the request grants access immediately.
                     Vendor approval happens inside Vertical Works. -->
                <vb-button variant="outline" size="sm" (click)="$event.stopPropagation(); openRequestAccessModal('Vertical Works', 'verticalWorks')">
                  Request Access
                </vb-button>
              }
            }
                      </div>
          </div>
        </vb-card>
        }
      </div>
    </section>

  </main>

  <app-footer />
</div>
}

<!-- Request Access Modal -->
<app-request-access-modal
  [isOpen]="isRequestModalOpen"
  [appName]="requestModalAppName"
  [appType]="requestModalAppType"
  [userName]="userName"
  [userEmail]="userEmail"
  (closed)="closeRequestAccessModal()"
  (submitted)="onRequestSubmitted()"
></app-request-access-modal>
